var _a;
// Types
import { Sizes } from './Sizes';
/**
 * Media query / container query breakpoints by size
 * The value provided are in pixels and represents the upper bound
 * @example Sizes.X_LARGE is anywhere between 1312px - 1584px
 * Anything beyond 1584px is maximum
 */
export var breakpoints = (_a = {},
    _a[Sizes.X_LARGE] = '1584px',
    _a[Sizes.LARGE] = '1312px',
    _a[Sizes.MEDIUM] = '1056px',
    _a[Sizes.SMALL] = '672px',
    _a[Sizes.X_SMALL] = '320px',
    _a);
//# sourceMappingURL=breakpoints.js.map